/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/
/*

(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();*/

// ATC Buttons
// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.product-card-atc').forEach(item => {
//     item.addEventListener('click', function (e) {
//       e.preventDefault();
//       let id = +item.getAttribute('data-variant-id');
//       let quantity = 1;
//       if (item.closest('.card-buttons').querySelector('.quantity-input') != null) {
//         quantity = +item.closest('.card-buttons').querySelector('.quantity-input').value;
//       }
//       fetch('/cart/add.js', {
//         method: 'post',
//         headers: {
//           'Content-Type': 'application/json;charset=utf-8'
//         },
//         body: JSON.stringify({
//           id,
//           quantity
//         })
//       }).then(response => response.json())
//           .then(result => {
//             document.dispatchEvent(new CustomEvent('theme:cart:reload', {
//               bubbles: true
//             }));
//             document.querySelector('[data-drawer-toggle="drawer-cart"]').click();
//           })
//     })
//   })
// })

// Handle Quantity Selection
function handleQuantitySelection(button) {
  let card = button.closest('.boost-pfs-filter-product-item-inner');
  let dropdownElement = card.querySelector('.quantity-dropdown');
  let quantityInput = card.querySelector('.quantity-input');
  dropdownElement.classList.toggle('active');

  let options = dropdownElement.querySelectorAll('span');
  options.forEach((option) => {
    option.removeEventListener('click', quantityOptionClickHandler); // Remove any existing event listeners
    option.addEventListener('click', quantityOptionClickHandler); // Add the event listener
  });

  function quantityOptionClickHandler() {
    dropdownElement.classList.remove('active');
    quantityInput.value = this.textContent;
  }
}

// Add to Cart Functionality
function handleAddToCart(event) {
  event.preventDefault();
  event.stopPropagation();
  let button = event.currentTarget;
  let card = button.closest('.boost-product-card__quick-atc');
  let quantityInput = card.querySelector('.quantity-input');
  let variantId = button.getAttribute('data-variant-id');

  // addToCart(variantId, quantityInput.value);
}

function addToCart(variantId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: parseInt(quantity)
    })
  })
  .then(response => response.json())
  .then(data => {
    document.dispatchEvent(new CustomEvent('theme:cart:reload', {
      bubbles: true
    }));
    document.querySelector('[data-drawer-toggle="drawer-cart"]').click();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Event Delegation for click events
document.body.addEventListener('click', (event) => {
  if (event.target.closest('.dropdown-toggle-collection')) {
    handleQuantitySelection(event.target.closest('.dropdown-toggle-collection'));
  }
});

// ENABLE SEARCH ON DESKTOP
let searchPopdown = document.querySelector('.search--popdown');
let popdownVisContainer = searchPopdown.querySelector('div[data-popdown-outer]')
let desktopSearchToggle = document.getElementById('header-search-toggle-desktop');
let searchUnderlay = document.querySelector('[data-search-underlay]');
let searchInput = searchPopdown.querySelector('[data-predictive-search-input]');

desktopSearchToggle.addEventListener('click', (e) => {
  e.preventDefault();
  showPopdown();
});

function showPopdown() {
  popdownVisContainer.classList.add('is-visible');
}

// BOOST OOS TOGGLE

// Function to handle the clicking of buttons once they are available
function handleStockFilterButtons() {
  let stockFilter = document.getElementById('boost-pfs-filter-tree2-pf-st-stock-status');
  if (stockFilter) {
      let stockFilterBtns = stockFilter.querySelectorAll('.boost-pfs-filter-button');
      const stockFilterBtnsArray = Array.from(stockFilterBtns);
      stockFilterBtnsArray.forEach((btn) => {
        if (stockFilterBtnsArray.indexOf(btn) === 0) {
          btn.click();
        }
      });
  }
}

// Create an observer instance linked to the callback function
const observer = new MutationObserver((mutationsList, observer) => {
  for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
          // Check if the stock filter buttons are available and then execute the function
          if (document.getElementById('boost-pfs-filter-tree2-pf-st-stock-status')) {
             // handleStockFilterButtons();
              // Once the target elements are found and handled, you can disconnect the observer
              observer.disconnect();
              break;
          }
      }
  }
});

// Configuration of the observer to watch for child nodes being added
const observerConfig = { childList: true, subtree: true };

// Start observing the target node for configured mutations
observer.observe(document.body, observerConfig);
